import React from 'react';
import './ContactPage.css';

const ContactPage = () => {
  return (
    <div className="contact-page">
      <section className="contact-page-header">
        {/* <div className="page-header-overlay"></div> */}
        <div className="page-header-container">
          <div className="container">
            <h1 className="page-title">
              <span className="highlight">Contact</span> Us
            </h1>
            <p className="page-subtitle">
              Get in touch with our team to discuss your specific requirements
            </p>
          </div>
        </div>
      </section>

      <div className="container">
        <div className="contact-content">
          <div className="contact-form-section">
            <h2 className="section-title">
              Send us a <span className="highlight">Message</span>
            </h2>
            <p>Fill out the form below and our team will get back to you shortly.</p>
            <form
                action="https://formspree.io/f/mdaaawjy"
                method="POST"
                className="contact-form"
                style={{ marginTop: '2rem', marginBottom: '2rem' }}
                >
                <div className="form-group">
                    <label>Name *</label>
                    <input type="text" name="name" required />
                </div>

                <div className="form-group">
                    <label>Company</label>
                    <input type="text" name="company" />
                </div>

                <div className="form-group">
                    <label>Designation</label>
                    <input type="text" name="designation" />
                </div>

                <div className="form-group">
                    <label>Phone Number *</label>
                    <input type="tel" name="phone" required />
                </div>

                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" />
                </div>

                <div className="form-group">
                    <label>Message *</label>
                    <textarea name="message" rows="5" required></textarea>
                </div>

                <button type="submit" className="btn primary" style={{ marginTop: '1rem' }}>
                    Send Message
                </button>
                </form>

          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
